import { connect } from 'react-redux';
import { selectSubscriptionBlock } from "../../../store/selectors";
var mapStateToProps = function mapStateToProps(state) {
  var subscriptionBlock = selectSubscriptionBlock(state);
  return {
    confirmationEmail: subscriptionBlock.texts.confirmationEmail,
    retryEmail: subscriptionBlock.texts.retryEmail
  };
};
export var connector = connect(mapStateToProps);